import { render, staticRenderFns } from "./responsiblemodal.vue.html?vue&type=template&id=0be4928f&scoped=true"
import script from "./responsiblemodal.controller.ts?vue&type=script&lang=js&external"
export * from "./responsiblemodal.controller.ts?vue&type=script&lang=js&external"
import style0 from "./responsiblemodal.vue.html?vue&type=style&index=0&id=0be4928f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4928f",
  null
  
)

export default component.exports